// removed by extract-text-webpack-plugin
module.exports = {"root":"clip-layout-menu__root","button":"clip-layout-menu__button","selected":"clip-layout-menu__selected","icon":"clip-layout-menu__icon"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/show-page/components/clip-layout-menu/styles.less
 ** module id = 433
 ** module chunks = 1
 **/